import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

import { CommandBar, ICommandBarItemProps, ProgressIndicator } from "@fluentui/react";
import CustomButton from "../CustomButton";
import { SubledgerContext } from "../../contexts/SubledgerContext";
import { UserContext } from "../../contexts/UserContext";
import { AuthenticationState } from "../../contexts/UserContext";
import { SLLoadingStatus } from "../../utilities/utilities";

function commandBarItems(history: any, userAuthenticated: AuthenticationState) {
  const onClickHandler = (route: string) => (event: React.MouseEvent | any) => {
    event.preventDefault();
    history.push(route);
  };
  const disabled = userAuthenticated !== AuthenticationState.Authenticated;
  const items: ICommandBarItemProps[] = [
    {
      key: "dashboard",
      iconProps: { iconName: "ViewDashboard" },
      text: "SL Dashboard",
      ariaLabel: "Subledger Dashboard",
      onClick: onClickHandler("/sldashboard"),
      disabled
    },
    {
      key: "slCreate",
      iconProps: { iconName: "OpenFile" },
      text: "SL Create",
      ariaLabel: "New Entry",
      onClick: onClickHandler("/slcreate"),
      disabled
    },
    {
      key: "slBatch",
      iconProps: { iconName: "BulkUpload" },
      text: "SL Batch",
      ariaLabel: "New Batch Entry",
      onClick: onClickHandler("/slbatch")
    },
    {
      key: "slSearch",
      iconProps: { iconName: "Search" },
      text: "SL Search",
      ariaLabel: "Search",
      onClick: onClickHandler("/slsearch"),
      disabled
    }
  ];

  return items;
}

enum NavigationLoadingStatus {
  Idle = "Idle",
  Pending = "Pending",
  Resolved = "Resolved",
  Rejected = "Rejected"
}
interface IUserSettings {
  isAdmin: boolean;
  hasPostingAccess: boolean;
  isReadOnly: boolean;
  loadingStatus: NavigationLoadingStatus;
}

const Navigation = (): JSX.Element => {
  const { status } = useContext(UserContext);
  const { userRoles } = useContext(SubledgerContext);
  const history = useHistory();
  const [userSettings, setUserSettings] = useState<IUserSettings>({
    isAdmin: false,
    hasPostingAccess: false,
    isReadOnly: true,
    loadingStatus: NavigationLoadingStatus.Idle
  });

  useEffect(() => {
    if (userRoles.status === SLLoadingStatus.Resolved) {
      setUserSettings({
        isAdmin: userRoles.value.isAdmin,
        hasPostingAccess: userRoles.value.hasPostingAccess,
        isReadOnly: userRoles.value.isReadOnly,
        loadingStatus: NavigationLoadingStatus.Resolved
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRoles.status]);

  return (
    <nav role="navigation">
      <CommandBar
        buttonAs={CustomButton}
        items={commandBarItems(history, status)}
        ariaLabel={"Use left and right arrow keys to navigate between commands"}
        overflowButtonProps={{ ariaLabel: "More commands", ariaDescription: "More commands available." }}
        styles={
          {
            icon: { color: "currentColor" }
          } as any
        }
      />
      {userSettings.loadingStatus === NavigationLoadingStatus.Idle ? (
        <ProgressIndicator
          ariaValueText="Loading User Roles"
          styles={{
            itemName: {
              display: "none"
            },
            itemDescription: {
              textAlign: "center"
            },
            itemProgress: {
              paddingTop: 0
            }
          }}
          description="Loading User Roles"
        />
      ) : null}
    </nav>
  );
};

Navigation.displayName = "Navigation";

export default Navigation;
